import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendProject,
  BackendProjectLastUsedScoringMethodArgs,
  BackendQueryProjectArgs,
} from 'src/types/backend';

const QUERY = gql`
  query ProjectScoringMethod($projectId: Int!, $generationTool: GenerationToolEnum!) {
    project(id: $projectId) {
      id

      lastUsedScoringMethod(generationTool: $generationTool) {
        id
        type
      }
    }
  }
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
  generationTool: BackendProjectLastUsedScoringMethodArgs['generationTool'];
};

export const queryProjectScoringMethod = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });

  const project = getSingleProp<BackendProject>(result.data);
  return project?.lastUsedScoringMethod;
};
